export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-all-300-normal.woff?075c0e20e32843429ade3beac2889e77";